import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Comission() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const comissions = (notifications || []).find(n => n.type === ENotificationType.COMISSION);
  if (!comissions?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.COMISSION}`}>
      <List.Item extra={<Badge count={comissions?.quantity || 0} color='blue' showZero />}>
        <Typography.Text strong>Nova Comissão</Typography.Text>
      </List.Item>
    </Link>
  );
}
